import React, { createContext, useContext, useState } from 'react';

type Theme = 'blue' | 'gold';

interface ThemeContextValue {
  theme: Theme;
  toggleTheme: () => void;
  accentColor: string;
}

const ThemeContext = createContext<ThemeContextValue | null>(null);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>('blue');
  const accentColor = theme === 'gold' ? '#d97706' : '#2563eb';

  const toggleTheme = () => setTheme((t) => (t === 'blue' ? 'gold' : 'blue'));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, accentColor }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextValue => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
};
